import React from 'react';

import PropTypes from 'prop-types';

import {
  getGlobalContext,
  useContextWithValidation,
} from '@adsk/alloy-react-context';

import {
  getOrCreatePluginContext,
  getContextKey,
} from '../helpers/pluginContexts';
import { pluginShape } from '../helpers/propTypes';
import useGetEntities from '../hooks/useGetEntities';

export const usePluginContext = (plugin) =>
  useContextWithValidation(getGlobalContext(getContextKey(plugin)), {
    hook: 'usePluginContext',
    provider: 'getContextKey(plugin)',
  });

const PluginEntitiesProvider = React.forwardRef(
  ({ children, plugin, entityIds }, ref) => {
    const PluginContext = getOrCreatePluginContext(plugin);
    const contextValue = useGetEntities(plugin, entityIds);

    return (
      <PluginContext.Provider ref={ref} value={contextValue}>
        {children}
      </PluginContext.Provider>
    );
  },
);

PluginEntitiesProvider.displayName = 'PluginEntitiesProvider';

PluginEntitiesProvider.propTypes = {
  /**
   * The plugin we want to fetch entities for.
   */
  plugin: pluginShape.isRequired,
  /**
   * Array of entity IDs we want to fetch.
   */
  entityIds: PropTypes.arrayOf(PropTypes.string),
  /**
   * The content of the provider.
   */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default PluginEntitiesProvider;
